export const APP_TIMEZONE = process.env.REACT_APP_PHARMACY_TIME_ZONE || "Canada/Pacific";

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const formatInAppTimezone = (value, options, locale = "en-US") => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(locale, {
    timeZone: APP_TIMEZONE,
    ...options,
  }).format(date);
};

export const formatDateToYYYYMMDDInAppTimezone = (value) => {
  if (value == null) return "";
  if (typeof value === "string" && DATE_ONLY_PATTERN.test(value)) return value;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return formatInAppTimezone(
    date,
    {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    "en-CA"
  ).replace(/\//g, "-");
};

export const getCurrentDayInAppTimezone = () =>
  formatInAppTimezone(new Date(), {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export const getCurrentDateTimeInAppTimezone = () =>
  formatInAppTimezone(new Date(), {
    hour12: true,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

export const getCurrentDateInAppTimezone = () =>
  formatDateToYYYYMMDDInAppTimezone(new Date());
